const { permissions } = require('../constants/permissions');
const TableState = require('../model/TableState');
const SERVER_API = 'api/v1/';
class IamPersistenceService {
    constructor($filter, $rootScope, $q, crudService, sharedPersistenceService, storageService) {
        this.crudService = crudService;
        this.$filter = $filter;
        this._$q = $q;
        this.$rootScope = $rootScope;
        this.storageService = storageService;
        this.sharedPersistenceService = sharedPersistenceService;
        this.REST_ENDPOINTS = this.sharedPersistenceService.getRestEndpoints();
        this.userTableState = new TableState();

    }

    getAllRoles(subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/roles`;

        if (!this.hasPermissions(permissions.ROLE_LIST)) {
            return this._$q((resolve) => { resolve([]) })
        }

        return this.crudService.get(url, null, null, null, null, null, true).then(res => {
            return res.data.entities;
        });
    }

    getDefaultRole(subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/roles/getDefault`;

        if (!this.hasPermissions(permissions.DEFAULT_ROLE_GET)) {
            return this._$q((resolve) => { resolve([]) })
        }

        return this.crudService.get(url, null, null, null, null, null, true).then(res => {
            return res.data.entities;
        });
    }

    setDefaultRole(role, subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/roles/${role}/setAsDefault`;

        return this.crudService.put(url, null, null, null, true).then(res => {
            return res.data
        })
    }

    getAllUsers(firstPage, subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/authorityRoles`;

        if (!this.hasPermissions(permissions.USER_LISTING)) {
            return this._$q((resolve) => { resolve([]) })
        }

        if (firstPage && this.userTableState) {
            this.userTableState.page = 1;
        }
        return this.crudService.getPaged(url, this.userTableState, 'identifier', null, null, 10, null, true).then(res => {
            this.userTableState = res.data.tableState;
            return res.data.entities;
        });
    }

    setUserRole(user, role, subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/authorityRoles/${user}`;

        const data = role;

        return this.crudService.put(url, data, null, null, true).then(res => {
            return res.data;
        })
    }

    activateUser(user, subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/users/${user}/activate`;

        return this.crudService.put(url, null, null, null, true).then(res => {
            return res.data
        })
    }

    deactivateUser(user, subscription) {
        let url = subscription.managerEndpointUrl + SERVER_API + 'subscriptions/' + subscription.value + `/${this.REST_ENDPOINTS.IAM_REST}/users/${user}/delete`;

        return this.crudService.put(url, null, null, null, true).then(res => {
            return res.data
        })
    }

    getPermissions(managerUrl, subscriptionUuid) {
        let url = managerUrl + SERVER_API + `subscriptions/${subscriptionUuid}/iam/permissions`;

        return this.crudService.get(url, null, null, null, null, null, true).then(res => {
            return res.data.entities;
        });
    }

    hasPermissions(permissionID, useTempPermissions) {
        const userPermissions = useTempPermissions ? this.storageService.getTempPermissions() : this.storageService.getPermissions();

        const neededPermissions = permissionID;

        if (userPermissions && neededPermissions.every(r => userPermissions.indexOf(r) !== -1)) {
            return true;
        } else {
            return false;
        }
    }

    // hasPermissions(permissionID) {
    //     const userPermissions = ['CLOUD_SUB_DELETE', 'SUB_INFO_GET', 'CLOUD_SUB_UPDATE', 'PS_DELETE', 'PS_UPDATE', 'PS_CREATE', 'ROLE_DEFAULT_ROLE_SET', 'USER_ACTIVATE', 'USER_DEACTIVATE', 'ROLE_LIST', 'ROLE_ASSIGN', 'ROLE_DEFAULT_ROLE_GET', 'ROLE_AUTHORITIES_LIST', 'RS_DELETE', 'RS_UPDATE', 'RV_EXPORT', 'RV_DELETE', 'RV_CREATE', 'RV_GET', 'REPORT_IMPORT', 'REPORT_EXPORT', 'RS_GET', 'REPORT_DELETE', 'REPORT_TAGS', 'REPORT_UPDATE', 'REPORT_CREATE', 'REPORT_DATA_GET', 'REPORT_LIST', 'REPORT_GET', 'WEBHOOK_UPDATE', 'WEBHOOK_DELETE', 'WEBHOOK_CREATE', 'EVENT_NTFC_DELETE', 'EVENT_NTFC_UPDATE', 'EVENT_NTFC_CREATE', 'WEBHOOK_GET', 'WEBHOOK_LIST', 'EVENT_NTFC_LIST', 'EVENT_GET', 'EVENT_LIST', 'TASK_ABORT', 'TASK_GET', 'TASK_LIST', 'TARGET_DELETE', 'TARGET_ACTIVATE', 'TARGET_DEACTIVATE', 'TARGET_UPDATE', 'TARGET_CREATE', 'TARGET_GET', 'TARGET_LIST', 'DEFAULT_POLICY_SET', 'BW_DELETE', 'BW_UPDATE', 'BW_CREATE', 'BW_GET', 'ARCHIVE_DELETE', 'ARCHIVE_UPDATE', 'ARCHIVE_CREATE', 'ARCHIVE_GET', 'BW_LIST', 'ARCHIVE_LIST', 'TARGET_LIST', 'POLICY_DELETE', 'POLICY_UPDATE', 'POLICY_CREATE', 'POLICY_LIST', 'POLICY_GET', 'SA_LIST', 'DEFAULT_SA_GET', 'VM_BACKUP_LIST', 'VM_BACKUP_GET', 'VM_BACKUP_EXPIRE', 'VM_GET', 'VM_LIST', 'VM_DOWNLOAD_KEY', 'VM_CRED_DELETE', 'VM_CRED_UPDATE', 'VM_CRED_CREATE', 'VM_POLICY_ASSIGN', 'VM_POLICY_UNASSIGN', 'POLICY_LIST', 'VM_BACKUP_CREATE', 'VM_RESTORE', 'VM_RESTORE_BROWSE', 'VM_CRED_GET', 'VM_CRED_UNASSIGN', 'VM_CRED_ASSIGN', 'VM_CRED_LIST', 'VM_CONF_GET', 'VM_CONF_UPDATE']
    //     const neededPermissions = permissionID;
    //     if (neededPermissions.every(r => userPermissions.includes(r))) {
    //         return true;
    //     } else {
    //         console.log('Did not find all of', neededPermissions, 'in', userPermissions);
    //         return false;
    //     }
    // }
}

IamPersistenceService.$inject = ['$filter', '$rootScope', '$q', 'crudService', 'sharedPersistenceService', 'storageService'];

module.exports = IamPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/iam.persistence.service.js